import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import emailjs from 'emailjs-com';
import "./ListingPreference.css";

const ListingPreference = () => {
  const formRef = useRef();

  const [formData, setFormData] = useState({
    name: "",
    locationPreference: "",
    propertyType: "",
    phoneNumber: "",
    size: "",
    type: "Residential",
  });

  const [sending, setSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatusMessage("");

    try {
      await emailjs.sendForm(
        "service_58m64j5",
        "template_utol5vi",
        formRef.current,
        "hAJmqdyYf07E3qAtY"
      );

      setStatusMessage("Your preferences have been submitted successfully.");
      setFormData({
        name: "",
        locationPreference: "",
        propertyType: "",
        phoneNumber: "",
        size: "",
        type: "Residential",
      });
      formRef.current.reset();
    } catch (error) {
      console.error("EmailJS error:", error);
      setStatusMessage(
        "There was an error sending your preferences. Please try again."
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="listing-preference-page">
      <Helmet>
        <title>Listing Preferences | Delta PMG</title>
        <meta
          name="description"
          content="Tell Delta PMG what kind of property you are looking for."
        />
        <link
          rel="canonical"
          href="https://www.deltapmg.com/listing-preferences"
        />
      </Helmet>

      <div className="listing-preference-wrapper">
        <div className="listing-preference-card">
          <h1>Didn&apos;t find what you are looking for?</h1>
          <p className="listing-preference-subtitle">
            Let us know your preferences and our team can keep them in mind.
          </p>

          <form ref={formRef} onSubmit={sendEmail} className="listing-preference-form">
            <div className="listing-preference-grid">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phoneNumber">Phone Number</label>
                <input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group full-width">
                <label htmlFor="locationPreference">Location Preference</label>
                <input
                  type="text"
                  id="locationPreference"
                  name="locationPreference"
                  value={formData.locationPreference}
                  onChange={handleChange}
                  placeholder="Example: Harrisburg, Camp Hill, Mechanicsburg"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="propertyType">Property Type</label>
                <input
                  type="text"
                  id="propertyType"
                  name="propertyType"
                  value={formData.propertyType}
                  onChange={handleChange}
                  placeholder="Example: Apartment, Office, Retail, House"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="size">Size</label>
                <input
                  type="text"
                  id="size"
                  name="size"
                  value={formData.size}
                  onChange={handleChange}
                  placeholder="Example: 2 bed / 2 bath or 1200 sqft"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="listing-preference-submit"
              disabled={sending}
            >
              {sending ? "Submitting..." : "Submit Preferences"}
            </button>

            {statusMessage && (
              <p className="listing-preference-status">{statusMessage}</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ListingPreference;